import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.COMMAND_API_URL;
/*
  CREATE
*/
/*
  SCANNERS
*/
export const getF2Token = async ({ token, data }) => {
    try {
        const response = await axios.post(`${API_URL}/vendors/f2`, {
            data: data
        }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getF2Token', error);
        return error.response;
    }
};
export const getF2TokenNew = async ({ token, data }) => {
    try {
        const response = await axios.post(`${API_URL}/vendors/f2-new`, {
            data: data
        }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getF2TokenNew', error);
        return error.response;
    }
};
/*
  READ
*/
export const getFontAwesome = async () => {
    try {
        const response = await axios.get(`${API_URL}/vendors/fontawesome`);
        return response;
    }
    catch (error) {
        handleError('getFontAwesome', error);
        return error.response;
    }
};
export const getTradesmith = async ({ id }) => {
    try {
        const response = await axios.get(`${API_URL}/vendors/tradesmith/${id}`);
        return response;
    }
    catch (error) {
        handleError('getTradesmith', error);
        return error.response;
    }
};
/*
  UPDATE
*/
/*
  DELETE
*/
//# sourceMappingURL=Vendors.js.map